<template>
  <div class='my-approval'>
      <SideLeftTree v-if="showTit" @changeLeftTree="changeLeftTree"/>
      <div class="content">
          <el-tabs type="card" v-model="tabName" @tab-click="handleTabClick">
              <!-- 我申请的 -->
              <el-tab-pane name="first" label="我申请的">
                 <el-tabs type="card" :tab-position="subTabPosition" v-model="applyTabName" @tab-click="handleApplyTabClick">
                      <!-- 申请中 -->
                      <el-tab-pane name="first" label="申请中">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply11" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj" :approvalStatus="11" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval" :selectedTemplate="selectedTemplate" @refreshTaskDetail="refreshTaskDetail"/>
                      </el-tab-pane>
                      <!-- 已通过 -->
                      <el-tab-pane name="second" label="申请通过">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply12" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj" :approvalStatus="12" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval" :selectedTemplate="selectedTemplate" @refreshTaskDetail="refreshTaskDetail"/>
                      </el-tab-pane>
                      <!-- 已驳回 -->
                      <el-tab-pane name="third" label="申请驳回">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply13" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="13" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval" :selectedTemplate="selectedTemplate"/>
                      </el-tab-pane>
                       <!-- 草稿 -->
                      <el-tab-pane name="fourth" label="草稿">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply10" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="10" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval" :selectedTemplate="selectedTemplate"/>
                      </el-tab-pane>
                       <!-- 全部 -->
                      <el-tab-pane name="fifth" label="全部">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply14" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="14" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval" :selectedTemplate="selectedTemplate"/>
                      </el-tab-pane>
                  </el-tabs>
              </el-tab-pane>
              <!-- 我审批的 -->
              <el-tab-pane name="second" label="我审批的">
                  <el-tabs type="card" :tab-position="subTabPosition" v-model="approvalTabName"  @tab-click="handleApprovalTabClick">
                      <!-- 待审批 -->
                      <el-tab-pane name="first" label="待审批">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply20" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="20" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval"/>
                      </el-tab-pane>
                      <!-- 已通过 -->
                      <el-tab-pane name="second" label="审批通过">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply21" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="21" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval"/>
                      </el-tab-pane>
                      <!-- 已驳回 -->
                      <el-tab-pane name="third" label="审批驳回">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply22" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="22" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval"/>
                      </el-tab-pane>
                       <!-- 全部 -->
                      <el-tab-pane name="fourth" label="全部">
                        <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" ref="approvalList" v-if="isShowApply23" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :approvalStatus="23" :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :onlyOneApproval="onlyOneApproval" :belongProcessFlag = "belongProcessFlag" @handleApplyTabClick="handleApplyTabClick" :isFullScreen="isFullScreen" @handleFullScreenForApproval="handleFullScreenForApproval"/>
                      </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
               <!-- 其他的 -->
              <el-tab-pane v-if="belongProcessFlag!=0" name="third" label="其他的">
                   <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" :processIsRead="processIsRead" ref="approvalList" v-if="isShowApply24" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :busiTaskInstanceId="busiTaskInstanceId" :belongProcessFlag = "belongProcessFlag" :isFullScreen="isFullScreen" :isOther="true"  @handleFullScreenForApproval="handleFullScreenForApproval" />
              </el-tab-pane>
              <el-tab-pane name="fourth" label="抄送的">
                   <ApprovalList :approveFromIds="approveModel.approveFromIds" :isOuterRead="isRead" :processIsRead="processIsRead" ref="approvalList" v-if="isShowApply25" :taskParam="taskParam" :processModelFormsObj="processModelFormsObj"  :busiProcessInstanceId="busiProcessInstanceId" :busiProcessInstanceName="busiProcessInstanceName" :isFullScreen="isFullScreen" :isCopyFlag="1" @handleFullScreenForApproval="handleFullScreenForApproval"/>
              </el-tab-pane>
          </el-tabs>
      </div>
  </div>
</template>

<script>
import ApprovalList from './ApprovalList';
import { isEmpty } from 'lodash';
export default {
    components: {
        ApprovalList
    },
    data () {
        return {
            isCollapse: true,
            tabName: 'first',
            applyTabName: 'first',
            approvalTabName: 'first',
            copyTabName: 'first',
            // tabPosition: 'top',
            subTabPosition: 'left',
            isShowApply10: false,
            isShowApply11: false,
            isShowApply12: false,
            isShowApply13: false,
            isShowApply14: false,
            isShowApply20: false,
            isShowApply21: false,
            isShowApply22: false,
            isShowApply23: false,
            isShowApply24: false,
            isShowApply25: false
        };
    },
    created () {
        this.resetShowStatus();
        let isShowApprovalModual = sessionStorage.getItem('isShowApprovalModual');// 显示审批标签
        if (!isEmpty(isShowApprovalModual)) {
            this.tabName = 'second';
            this.approvalTabName = 'first';
            this.isShowApply20 = true;
            sessionStorage.removeItem('isShowApprovalModual');
        } else { // 显示申请标签
            let isShowApprovalDraft = sessionStorage.getItem('isShowApprovalDraft');
            if (!isEmpty(isShowApprovalDraft)) { // 是否显示草稿页签
                this.applyTabName = 'fourth';
                this.isShowApply10 = true;
                sessionStorage.removeItem('isShowApprovalDraft');
            } else {
                this.tabName = 'first';
                this.applyTabName = 'first';
                this.isShowApply11 = true;
            }
        }
    },
    computed: {
    },
    watch: {
    },
    props: {
        approveModel: {
            type: Object,
            default: () => {
                return {
                    approveModelIds: '',
                    approveFromIds: ''
                };
            }
        },
        showTit: {
            type: Boolean,
            default: false
        },
        showLeftSwitch: {
            type: Boolean,
            default: false
        },
        taskParam: {// 任务对象,用于暂存
            type: Object
        },
        busiProcessInstanceId: {
            type: String
        },
        busiProcessInstanceName: {
            type: String
        },
        busiTaskInstanceId: {
            type: String
        },
        onlyOneApproval: { // 任务中的审批流，是否设置了只能发起一条审批的配置。0否1是
            type: Number,
            default: 0
        },
        belongProcessFlag: {
            type: Number,
            default: 0
        },
        isFullScreen: { // 是否全屏
            type: Boolean,
            default: true
        },
        selectedTemplate: {
            type: Array,
            default: () => { return []; }
        },
        isRead: {
            type: Boolean,
            default: false
        },
        processIsRead: {// 我的流程查看审批流详情
            type: Boolean,
            default: false
        },
        processModelFormsObj: {
            type: Array
        }
    },
    methods: {
        handleTabClick (tab, event) {
            this.resetShowStatus();
            if (tab.index === '0') {
                this.applyTabName = 'first';
                this.isShowApply11 = true;
            } else if (tab.index === '1') {
                this.approvalTabName = 'first';
                this.isShowApply20 = true;
            } else if (tab.index === '2') { // 其他的
                this.isShowApply24 = true;
                if (this.belongProcessFlag === 0) { // 抄送的
                    this.isShowApply25 = true;
                }
            } else if (tab.index === '3') { // 抄送的
                this.isShowApply25 = true;
            }
        },
        handleApplyTabClick (tab, event) {
            this.resetShowStatus();
            if (tab.index === '0') {
                this.applyTabName = 'first';
                this.isShowApply11 = true;
            } else if (tab.index === '1') {
                this.isShowApply12 = true;
            } else if (tab.index === '2') {
                this.isShowApply13 = true;
            } else if (tab.index === '3') {
                this.applyTabName = 'fourth';
                this.isShowApply10 = true;
            } else if (tab.index === '4') {
                this.isShowApply14 = true;
            }
        },
        handleApprovalTabClick (tab, event) {
            this.resetShowStatus();
            if (tab.index === '0') {
                this.isShowApply20 = true;
            } else if (tab.index === '1') {
                this.isShowApply21 = true;
            } else if (tab.index === '2') {
                this.isShowApply22 = true;
            } else if (tab.index === '3') {
                this.isShowApply23 = true;
            }
        },
        resetShowStatus () {
            this.isShowApply10 = false;
            this.isShowApply11 = false;
            this.isShowApply12 = false;
            this.isShowApply13 = false;
            this.isShowApply14 = false;
            this.isShowApply20 = false;
            this.isShowApply21 = false;
            this.isShowApply22 = false;
            this.isShowApply23 = false;
            this.isShowApply24 = false;
            this.isShowApply25 = false;
        },
        handleFullScreenForApproval () {
            this.$emit('handleFullScreenForApproval');
        },
        handleRefrenshApprovalList () {
            this.$refs.approvalList._getFormData();
        },
        handlePopApprovalTemplate () {
            this.$refs.approvalList.handleNavAdd();
        },
        collapseLeftSide () {
            this.$emit('collapseLeftSide', this.isCollapse);
        },
        refreshTaskDetail () {
            this.$emit('refreshTaskDetail', true);
            // 发起审批成功以后不需要主动刷新整个任务数据，直接刷新审批列表即可。
            setTimeout(() => {
                this.$refs.approvalList._getFormData();
            }, 100);
        },
        changeLeftTree (isCollapse) {
            this.$emit('collapseLeftSide', isCollapse);
        }
    }
};
</script>


<style lang="less" scoped="scoped">
.my-approval{
    width: 100%;
    margin-left: 10px;
    margin-top: 10px;
    height: ~"calc(100% - 3vh)";
    .top{
        margin-top: 1vw;
        margin-bottom: 1vw;
        display: flex;
        .left{
            width: 4vw;
        }
        .right{
             width: 20vw;
        }
    }
    .el-tabs__content{
      margin-top: -5px;
    }
    .el-dialog__footer{
        padding: 5px 20px 10px;
    }
    .el-dialog__body{
      padding: 5px 5px;
    }
    .el-dialog__wrapper{
      overflow:hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/process/MyApproval/MyApproval.vue